import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { IconButton } from '@ui/components/Button'
import { Tooltip } from '@ui/components/Tooltip/Tooltip'
import { EditIcon } from '@ui/icons/Edit.icon'
import {
  SensitiveTableCell,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@ui/v2/Table/Table'
import { SummaryItem } from '@ui/v2/TableSummary/TableSummary'

import { useWindowResize } from '@utils/domUtils'

import { CommissionPlanData } from './useCommissionPlans'

import styles from '../SubIBAccounts/SubIBAccountsPage.module.scss'

interface Props {
  sticky?: 'left'
  commissionPlansSummary: SummaryItem[]
  commissionPlans: CommissionPlanData[]
  onEdit: (group: CommissionPlanData) => void
  isLoading?: boolean
}

export const CommissionPlansTable: FC<Props> = (props) => {
  const { commissionPlans, isLoading = false, onEdit, sticky, commissionPlansSummary } = props

  const { t } = useTranslation()
  const isMobile = useWindowResize()

  const normalizeTitle = (title: string) => {
    if (title.trim().toLowerCase() === 'default plan') {
      return t('IB.MultiTier.Default Plan')
    }
    return title
  }

  return (
    <Table isLoading={isLoading} noResults={!commissionPlans.length} sticky={sticky}>
      <TableHeader>
        <TableRow>
          <TableHead>{t('IB.MultiTier.IB Commission Plans')}</TableHead>
          {commissionPlansSummary.map((plan) => (
            <TableHead align='right' key={plan.title}>
              {plan.title}
            </TableHead>
          ))}
          <TableHead align='right' />
        </TableRow>
      </TableHeader>
      <TableBody>
        {commissionPlans.map((data) => (
          <TableRow key={data.id}>
            <SensitiveTableCell>{normalizeTitle(data.name)}</SensitiveTableCell>

            {commissionPlansSummary.map((summaryItem) => (
              <SensitiveTableCell
                align='right'
                key={summaryItem.title}
                className={styles.tableCellCommissionPlan}
                width={246}
              >
                {
                  data.commissionPlans.find(
                    (commissionPlan) => commissionPlan.tradingAccountType.name === summaryItem.title
                  )?.amount
                }
              </SensitiveTableCell>
            ))}

            <TableCell align='right' width={246} className={styles.tableCellCommissionPlan}>
              {!data.isDefault &&
                (isMobile ? (
                  <IconButton.Ghost icon={EditIcon} onClick={() => onEdit(data)} />
                ) : (
                  <Tooltip direction='top' content={t('Edit')}>
                    <IconButton.Ghost icon={EditIcon} onClick={() => onEdit(data)} />
                  </Tooltip>
                ))}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
